import { Component, inject, OnInit } from '@angular/core';
import { StreamreportService } from '../../../service/streamreport.service';
import { TokenUsageByStream } from '../../../lib/interfaces/generic-streams';

@Component({
    selector: 'app-token-summary',
    standalone: false,
    templateUrl: './token-summary.component.html',
    styleUrl: './token-summary.component.scss'
})
export class TokenSummaryComponent implements OnInit {
    private reportService = inject(StreamreportService)
    public tokenData: TokenUsageByStream[] = [];

    public defaultInputCost = 0.00000233;
    public defaultOutputCost = 0.00000932;
    public tokenCosts: Record<string, { input: number; output: number }> = {
        "gpt-4o": {
            input: 0.00000233,
            output: 0.00000932,
        },
        "pgt-4o-mini": {
            input: 0.00000013982,
            output: 0.0000005593,
        },
    }
    async ngOnInit(): Promise<void> {
        const result = await this.reportService.getTokenSummary();
        if (result !== false) {
            this.tokenData = result;
        }
    }

    async getCsv(): Promise<void> {
        const csvData = this.createCsvData();
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'token_summary.csv';
        a.click();
    }

    createCsvData(): string {
        let data = `"Streamname";`
        data += `"Stepname";`
        data += `"LLM";`
        data += `"Vorkommnisse";`
        data += `"total Prompt Token";`
        data += `"total Response Token";`
        data += `"durchschnittliche Token";`
        data += `"Kosten Input €";`
        data += `"Kosten Output €";`
        data += `"Kosten Total €";`
        data += `"Kosten Durchschnitt €"\n`


        for (const rep of this.tokenData) {
            let costInput = this.tokenCosts[rep.llmId]?.input || this.defaultInputCost;
            let costOutput = this.tokenCosts[rep.llmId]?.output || this.defaultOutputCost;

            data += `"${rep.streamName || rep.streamTypeId}";`
            data += `"${rep.stepName || rep.stepId}";`
            data += `"${rep.llmId || "gto-4o"}";`
            data += `"${rep.groupCount}";`
            data += `"${rep.totalPromptTokens}";`
            data += `"${rep.totalResponseTokens}";`
            data += `"${(rep.totalTokens / rep.groupCount).toFixed(2)}";`
            data += `"${(rep.totalPromptTokens * costInput).toFixed(2)}";`
            data += `"${(rep.totalResponseTokens * costOutput).toFixed(2)}";`
            data += `"${((rep.totalPromptTokens * costInput) + (rep.totalResponseTokens * costOutput)).toFixed(2)}";`
            data += `"${(((rep.totalPromptTokens * costInput) + (rep.totalResponseTokens * costOutput)) / rep.groupCount).toFixed(4)}";\n`
        }
        return data;
    }
}
